import { GeneralCard, TableCard } from "@ui/internal/components/card";

import { endpoint } from "@services/api.services";
import FilterPopover from "@ui/internal/components/filter-popover";
import { usePathname } from "@utils/hook/index.hook";
import { QueryData } from "@utils/interface/index.interface";
import { useListData } from "@utils/query/index.query";
import { useMetaStore } from "@utils/states/index.state";
import { format } from "date-fns";
import { useEffect } from "react";
import { useSearchParams } from "react-router";
import { ColumnList } from "./column/index.column";
import MicroSoftTeamsForm from "./form/mteams.form";
import { useMutation } from "@tanstack/react-query";
import { showToast } from "@utils/helper/index.helper";
import { MicroSoftTeamsResendEmail } from "@services/MicrosoftTeamsServices";

const Index = () => {
  const pathname = usePathname();
  const [searchParams, setSearchParams] = useSearchParams();
  const { search, date } = useMetaStore();
  /* ================================================= api calls logic ================================================= */
  const { data, isPending, refetch, error } = useListData<QueryData<any>>({
    params: {
      page: searchParams.get("tpage") || 1,
      size: searchParams.get("per") || 10,
      search,
      created_date__gte: date.from ? format(date.from, "yyyy-MM-dd") : "",
      created_date__lte: date.to ? format(date.to, "yyyy-MM-dd") : "",
      ordering: searchParams.get("ordering") || "order",
    },
    endpoint: endpoint["teamsLicense"],
    key: `${pathname}-listing`,
  });

  const { mutate: resendEmail, isPending: resendEmailPending } = useMutation({
    mutationFn: MicroSoftTeamsResendEmail,
    onSuccess: (response: any) => {
      refetch();
      // Extract the image URL/ID from the response - adjust based on your API response structure
      showToast({
        title: "Resend Email",
        description: response.message || "Email Resent Successfully",
        type: "success",
      });
    },
    onError: (error) => {
      console.error("Ishow update failed", error);
      showToast({
        title: "Resend Email",
        description: error.message || "Email Resend Failed",
        type: "error",
      });
      // setIsUploading(false);
      // Handle error - show toast notification, etc.
    },
  });

  const columns = ColumnList({ resendEmail, resendEmailPending });
  useEffect(() => {
    if (error?.status === 404 && error?.data?.detail === "Invalid page.") {
      searchParams.set("tpage", "1");
      setSearchParams(searchParams);
    }
  }, [error]);
  return (
    <>
      <TableCard
        bulkActions
        // inject_ui_table_actions={
        //   <FilterPopover
        //     filters={[
        //       {
        //         label: "Designation",
        //         endpointValue: "mentor-designation",
        //         format: { key: "name", value: "id" },
        //       },
        //     ]}
        //     title="Filter"
        //     triggerText="Filter"
        //   />
        // }
        table_content={{
          mode: "default",
          type: pathname,
        }}
        sortableFilter={{
          search: search,
          // designation: searchParams.get("mentor-designation") || "",
          ordering: searchParams.get("ordering") || "order",
        }}
        showOrientation
        grid={
          <GeneralCard
            isChecked={false}
            type={"mentor"}
            // content={{
            //   images: [TestImage, TestImage, TestImage],
            //   title: "Aayush Maharjan",
            //   subtitle: "Frontend Developer",
            // }}
            showCheck
            onDelete={() => {}}
            onEdit={() => {}}
          />
        }
        form={<MicroSoftTeamsForm />}
        refetch={refetch}
        endpoint={endpoint["teamsLicense"]}
        columns={columns}
        isPending={isPending}
        rows={data?.data?.results ?? []}
        count={data?.data?.count ?? 10}
      />
    </>
  );
};

export default Index;
